var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 22,
    viewBox: "0 0 137 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1672 3.36917C46.5291 2.39436 45.6297 1.64065 44.4513 1.11054C43.2806 0.575399 41.8937 0.3116 40.3009 0.3116H28.6987V3.70582H37.2961H40.0698C41.3184 3.70582 42.2706 3.97716 42.9213 4.51732C43.572 5.05748 43.8961 5.83129 43.8961 6.84378C43.8961 7.83366 43.572 8.60245 42.9213 9.14261C42.2706 9.68277 41.3184 9.94908 40.0698 9.94908H36.6755H32.515V18.3053H36.6755V13.3458H40.3009C41.8937 13.3458 43.2806 13.082 44.4513 12.562C45.6271 12.0369 46.5291 11.2832 47.1672 10.2983C47.8003 9.31345 48.1169 8.16278 48.1169 6.84378C48.1169 5.5072 47.8003 4.34899 47.1672 3.36917Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9023 12.5243C66.0831 12.0092 66.9951 11.2706 67.6407 10.3008C68.2839 9.33605 68.6005 8.17784 68.6005 6.84628C68.6005 5.5097 68.2864 4.35149 67.6508 3.37167C67.0177 2.39686 66.1132 1.64315 64.9399 1.11304C63.7641 0.577902 62.3823 0.314102 60.7895 0.314102H52.9986V3.70581H57.9028V3.71084H60.5533C61.807 3.71084 62.7592 3.97966 63.4099 4.51982C64.0606 5.05998 64.3847 5.8338 64.3847 6.84628C64.3847 7.83616 64.0606 8.60997 63.4099 9.16018C62.7592 9.70788 61.807 9.96415 60.5533 9.96415H57.1616H52.9961V18.3052H57.1616V13.293H60.993L64.4651 18.3052H68.9346L64.9023 12.5243Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0936 4.53986C90.2369 3.1279 89.0661 2.01743 87.5712 1.21347C86.0814 0.404483 84.4006 0.00250244 82.5339 0.00250244C80.6672 0.00250244 78.9814 0.404483 77.4866 1.21347C75.9816 2.01743 74.8109 3.13041 73.9642 4.53986C73.1175 5.95684 72.6904 7.54466 72.6904 9.30835C72.6904 11.072 73.1175 12.6649 73.9642 14.0768C74.8109 15.4938 75.9842 16.5993 77.4866 17.4032C78.9814 18.2122 80.6672 18.6142 82.5339 18.6142C84.4006 18.6142 86.0814 18.2122 87.5712 17.4032C89.0661 16.5993 90.2369 15.4913 91.0936 14.0768C91.9503 12.6649 92.3774 11.072 92.3774 9.30835C92.3774 7.54466 91.9503 5.95684 91.0936 4.53986ZM87.4331 12.2931C86.9431 13.1649 86.2723 13.8457 85.4131 14.3356C84.5564 14.8205 83.5941 15.0667 82.5314 15.0667C81.4687 15.0667 80.5115 14.8205 79.6547 14.3356C78.798 13.8457 78.1247 13.1649 77.6348 12.2931C77.1449 11.4162 76.9037 10.4213 76.9037 9.30835C76.9037 8.19537 77.1449 7.20046 77.6348 6.32867C78.1247 5.45185 78.7955 4.77099 79.6547 4.28611C80.5115 3.79619 81.4687 3.54998 82.5314 3.54998C83.5941 3.54998 84.5564 3.79619 85.4131 4.28611C86.2698 4.77099 86.9431 5.45185 87.4331 6.32867C87.918 7.20046 88.1642 8.19537 88.1642 9.30835C88.1617 10.4213 87.918 11.4162 87.4331 12.2931Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M109.6 14.2979C108.64 14.813 107.562 15.0667 106.362 15.0667C105.228 15.0667 104.226 14.8205 103.339 14.3356C102.457 13.8457 101.771 13.1649 101.271 12.2931C100.777 11.4162 100.528 10.4213 100.528 9.30836C100.528 8.17528 100.777 7.17786 101.271 6.29853C101.771 5.42674 102.462 4.75091 103.354 4.27104C104.246 3.79118 105.266 3.54999 106.412 3.54999C108.231 3.54999 109.778 4.22582 111.067 5.57748L113.738 3.11284C112.866 2.10286 111.788 1.32905 110.499 0.798936C109.216 0.2638 107.784 0 106.206 0C104.324 0 102.623 0.401981 101.118 1.19589C99.6083 1.99483 98.4325 3.09776 97.5808 4.51223C96.7341 5.92419 96.312 7.52206 96.312 9.30334C96.312 11.0871 96.7341 12.685 97.5808 14.097C98.4325 15.5139 99.6007 16.6169 101.088 17.4133C102.583 18.2122 104.259 18.6092 106.13 18.6092C107.429 18.6092 108.723 18.4132 110.012 18.0163C111.296 17.6243 112.429 17.0616 113.404 16.3204V10.6022H109.6V14.2979Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M128.955 0.3116H124.84L116.823 18.3053H121.091L122.375 15.1924H122.36L124.551 9.97923H124.561L126.875 4.39673L129.726 11.2857H129.721L131.03 14.4462H131.04L132.633 18.3027H137L128.955 0.3116Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7372 0.331604H0V3.92179H19.7372V0.331604Z",
    fill: "url(#paint0_linear_262_2)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.953 6.21808H0V9.80827H23.953V6.21808Z",
    fill: "url(#paint1_linear_262_2)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8629 12.1021H0V15.6923H19.8629V12.1021Z",
    fill: "url(#paint2_linear_262_2)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67517 17.9886H0V21.5787H9.67517V17.9886Z",
    fill: "url(#paint3_linear_262_2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_262_2",
    x1: -8.06441,
    y1: 2.12728,
    x2: 19.4251,
    y2: 2.12728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58398E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#B267A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_262_2",
    x1: -8.06441,
    y1: 8.01249,
    x2: 19.4251,
    y2: 8.01249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58398E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#B267A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_262_2",
    x1: -8.06441,
    y1: 13.8977,
    x2: 19.4251,
    y2: 13.8977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58398E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#B267A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_262_2",
    x1: -8.06441,
    y1: 19.7829,
    x2: 19.4251,
    y2: 19.7829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58398E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#B267A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/LogoWhite.add26a5225b0b8eacd6393bad5713636.svg";
export { ForwardRef as ReactComponent };